<template>
  <div class="special-instructions">
    <h3 class="special-options__title">Special Instructions</h3>
    <textarea
      ref="textarea"
      v-model="instructions"
      placeholder="Add any special instructions for this item"
      class="special-instructions__input"
      @update:modelValue="onInput"
    >
    </textarea>
    <p>{{ Math.abs(characterLimit) }} characters left</p>
  </div>
</template>

<script>
export default {
  name: "SpecialInstructions",
  props: {
    modelValue: { type: String, default: "" },
    maxCharacters: { type: Number, default: 500 }
  },
  data() {
    return {
      instructions: this.modelValue
    };
  },
  computed: {
    characterLimit() {
      return this.modelValue.length - this.maxCharacters;
    }
  },
  methods: {
    onInput() {
      this.instructions = this.instructions.substring(0, this.maxCharacters);
      this.$emit("update:modelValue", this.instructions);
      this.$refs.textarea.style.height = "auto";
    }
  }
};
</script>

<style lang="scss">
.special-instructions {
  display: flex;
  flex-direction: column;

  h3 {
    font-size: 20px;
    padding: 20px 0 16px;
  }

  p {
    color: --group-3-color-3;
    font-size: 14px;
    line-height: 24px;
    margin: 4px 0 24px;
    text-align: right;
  }

  &__input {
    border-radius: 2px;
    border: 1px solid $group-3-color-3-alpha-40;
    box-sizing: border-box;
    color: --group-3-color-2;
    font-family: $fontFamilyPrimary;
    line-height: 1.2;
    max-height: 100px;
    min-height: 57px;
    outline: none;
    padding: 8px 16px;
    resize: initial;

    &::placeholder {
      color: --group-3-color-2;
      opacity: 0.4;
    }

    @include respond-to-mobile {
      min-height: 70px;
    }
  }
}
</style>
